import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { SelectedPanelEnum } from '@app/core/enums/selected-panel.enum';
import { MyZoneRoutesEnum } from '@app/my-zone/my-zone-routes.enum';
import { NotificationBannerIdEnum } from '@app/my-zone/shared/notification-banner/notification-banner-id.enum';
import { AppRoutesEnum } from '@app/routes';
import { DateService, PurchasedProductInterface } from 'outshared-lib';
import { CookieStorage, StorageService } from '@inshared/shared/util-storage';

@Component({
    selector: 'ins-notification-banner',
    templateUrl: './notification-banner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./notification-banner.component.scss'],
})

export class NotificationBannerComponent {

    @Input() public purchasedProducts: PurchasedProductInterface[];
    @Input() public notificationBanner: boolean;
    @Input() public notifications: { id: string, rank: number; }[] = [];

    @Output() public readonly toggle: EventEmitter<boolean> = new EventEmitter();

    private expireDate: string = this.dateService.add(3, 'day');
    public notificationBannerIdEnum = NotificationBannerIdEnum;

    constructor(
        private router: Router,
        private readonly dateService: DateService,
        @Inject(StorageService) private storage: CookieStorage,
    ) {
    }

    public setClaimYearsCookie(count: number): void {
        this.storage.setItem('Is.sjvg', count.toString(), { expires: +this.expireDate });
        this.toggle.emit(false);
    }

    public navigateToInsurance(): boolean {
        this.router.navigate([AppRoutesEnum.MyZone, MyZoneRoutesEnum.MyInsurances], {
            queryParams: {
                productSequenceNumber: this.purchasedProducts[0]?.productSequenceNumber,
                productId: this.purchasedProducts[0]?.productId,
                panel: SelectedPanelEnum.InsuranceStartDateSet,
            },
        });

        return false;
    }
}
